import { Button as MantineButton } from '@mantine/core';
import { clsx } from 'clsx';
import { ComponentProps } from 'react';

import { map } from '@/shared/utils';

import styles from './button.module.scss';

type ButtonType = 'Primary' | 'Secondary' | 'Outlined';

type ButtonProps = ComponentProps<typeof MantineButton<'button'>> & {
  buttonType?: ButtonType;
};

// TODO: Нужно добавить type=Icon в соответствии с макетом
export function Button({ buttonType = 'Primary', ...props }: ButtonProps) {
  return (
    <MantineButton
      {...props}
      className={clsx(
        styles.button,
        props?.className,
        map<ButtonType, string>(
          {
            Primary: styles.buttonPrimary,
            Secondary: styles.buttonSecondary,
            Outlined: styles.buttonOutlined,
          },
          buttonType,
        ),
      )}
    >
      {props.children}
    </MantineButton>
  );
}
